export default "__VITE_ASSET__73178a41__"